export default __webpack_public_path__ + "static/media/group-635@3x.07184ca0.png";